<script setup lang="ts">
import IconBenchmarkLogoBig from '@/assets/icons/benchmark-logo-big-white.svg'
import BenchmarkLogo from '@/assets/icons/benchmark-logo-black.svg'
import { useGoogleAnalyticsPageView } from '~/composables/google-analytics'

const bgStyles = {
  backgroundImage:
    'url("https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1672543364/source-assets/homepage_newsletter_banner_sho2y4_o8xmzl.avif?_i=AA")',
  backgroundPosition: 'center',
}
const { $seoManager } = useNuxtApp()

const seo = $seoManager.generateSeoInfo({
  title: 'About',
})
useHead(seo)
useGoogleAnalyticsPageView(seo.title)
</script>

<template>
  <div class="mt-0 border-t border-s-400/60 pb-0 lg:mt-10 lg:border-none">
    <!-- Cover -->
    <div class="lg:px-5">
      <div
        :style="bgStyles"
        class="mx-auto flex h-[300px] max-w-content-container flex-col items-center justify-center px-5 font-extralight md:h-[486px] md:px-10"
      >
        <IconBenchmarkLogoBig class="w-full" />
      </div>
    </div>
    <article>
      <!-- Content -->
      <div class="px-5">
        <section
          class="relative mx-auto mt-10 flex max-w-content-container flex-col items-center gap-y-4 overflow-hidden lg:flex-row"
        >
          <div class="flex flex-col gap-y-4 lg:w-1/2">
            <p class="text-xl md:text-2xl">
              <strong>Benchmark Source</strong>
              is brought to you by
              <strong>Benchmark Mineral Intelligence</strong>
            </p>
            <p>
              From raw materials through to the critical technology of the
              energy transition, <strong>Benchmark Source</strong> provides you
              with expert analysis, opinion pieces, data visualisations, video
              content and presentations covering key global developments.
            </p>
            <p>
              Drawing on <strong>Benchmark’s</strong> in-house teams of
              analysts, proprietary datasets, and extensive contacts,
              <strong>Benchmark Source</strong>
              provides subscribers with unparalleled insights into the supply
              chains of the energy transition.
            </p>
            <h4><strong>Benchmark Source</strong> subscribers receive:</h4>
            <ul class="ml-7 list-disc">
              <li>
                Daily analysis of critical themes and developments across the
                energy transition’s supply chains
              </li>
              <li>
                Commentary and opinion from Benchmark’s analysts and industry
                leaders
              </li>
              <li> Data visualisations and insights </li>
              <li>
                Exclusive video content including interviews and presentations
              </li>
              <li>
                Benchmark Mineral Intelligence’s Quarterly Review magazine
                (print and digital)
              </li>
              <li>
                Access to Benchmark Benchmark Mineral Intelligence’s
                presentation and magazine archives
              </li>
              <li>Exclusive subscriber-only weekly newsletter </li>
            </ul>
            <div class="ml-6 flex flex-col items-start">
              <BaseButton
                variant="primary"
                @click="$modal.open('requestATrial')"
              >
                Request a trial
              </BaseButton>
            </div>
          </div>
          <div class="lg:w-1/2">
            <img
              src="https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,g_auto,f_auto,c_fill,w_1536/v1700845139/assets/about/Geography_rhkdwe.png"
              alt="Benchmark Mineral Intelligence locations in the world map"
              class="h-[187px] w-full md:h-auto"
            />
          </div>
        </section>
      </div>
      <div class="container-footer py-16">
        <div class="px-5 lg:flex-row">
          <div
            class="mx-auto flex max-w-content-container flex-col gap-y-4 lg:flex-row"
          >
            <div class="pr-10"><BenchmarkLogo /></div>
            <div class="flex flex-col gap-y-4">
              <h2 class="text-2xl font-bold text-p-500">
                About Benchmark Mineral Intelligence
              </h2>

              <p>
                <strong>Benchmark Mineral Intelligence</strong>
                (<strong>Benchmark</strong>) is the world’s leading
                IOSCO-regulated price reporting agency (PRA), proprietary data
                provider, and market intelligence publisher for the lithium ion
                battery to electric vehicle (EV) supply chain.
              </p>

              <p>
                Our granular and expert focus on the entire supply chain makes
                us unique: from lithium and cobalt mining through to the
                manufacturing of cathode and anode functional materials, to
                battery cell and EV production.
              </p>

              <p>
                At Benchmark, we set the lithium industry’s reference and
                benchmark pricing. Our series of price assessment and data
                methodologies allow us to collect our proprietary data from the
                source, creating data that is relied upon by the industry to
                make multi-billion dollar investment decisions that accelerates
                the energy storage revolution.
              </p>

              <p>
                Benchmark’s tireless and methodical data collection coupled with
                in-house expert analysis makes us entirely unique in the 21st
                century publishing space and the world’s most trusted service.
              </p>

              <p>
                As a result, our services are relied upon by major actors in the
                EV supply chain, we have testified to the US Senate multiple
                times, advised The White House, The Pentagon, and government
                agencies around the world.
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<style lang="scss" scoped>
.container-footer {
  background-image: url('https://res.cloudinary.com/benchmarkminerals/image/upload/v1672338923/assets/background-about_uwf3je.png');
  background-repeat: no-repeat;
}
</style>
